import { Content } from '../../squidex/models/content.model';
const cloneDeep = require('lodash.clonedeep');


export class DynamicContentModel extends Content {
  constructor(content?: Partial<Content>) {
    if (content) {
      super(cloneDeep(content));
    } else {
      super({});
    }
  }
}
